import { render, staticRenderFns } from "./renewalInfo.vue?vue&type=template&id=6542a826&scoped=true"
import script from "./renewalInfo.vue?vue&type=script&lang=js"
export * from "./renewalInfo.vue?vue&type=script&lang=js"
import style0 from "./renewalInfo.vue?vue&type=style&index=0&id=6542a826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542a826",
  null
  
)

export default component.exports